import * as lib from 'Root/lib/lib.js'
import ajaxMixins from 'Root/vue/mixins/ajaxMixins'
import Loader from 'Root/vue/components/Loader.vue'
import ChequesFilters from 'Root/vue/components/Cheques/ChequesFilters.vue'
import ChequesResultsPerfecture from 'Root/vue/components/Cheques/ChequesResultsPerfecture.vue'
import ChequesResultsCountry from 'Root/vue/components/Cheques/ChequesResultsCountry.vue'
import ResponseError from 'Root/vue/components/ResponseError.vue'

export default {
    components: {
        Loader,
        'cheques-filters': ChequesFilters,
        resultsPerfecture: ChequesResultsPerfecture,
        resultsCountry: ChequesResultsCountry,
        'response-error': ResponseError,
    },

    mixins: [ajaxMixins],

    data() {
        return {
            loading: false,
            hasError: false,
            errorMessages: '',

            category: null,
            perfecture: null,

            results: null,

            resultsTypes: {
                perfecture: {
                    component: 'resultsPerfecture',
                    tabs: {
                        activeId: null,
                        links: [
                            {
                                id: 'byYear',
                                text: this.appData?.dictionary?.byYearLinkTitle,
                            },
                            {
                                id: 'byMonth',
                                text: this.appData?.dictionary?.byMonthLinkTitle,
                            },
                            {
                                id: 'byMonthMO',
                                text: this.appData?.dictionary?.byMonthAverageLinkTitle,
                            },
                        ],
                    },
                },
                country: {
                    component: 'resultsCountry',
                    tabs: {
                        activeId: null,
                        links: [
                            {
                                id: 'byYear',
                                text: this.appData?.dictionary?.byYearLinkTitle,
                            },
                            {
                                id: 'byMonth',
                                text: this.appData?.dictionary?.byMonthLinkTitle,
                            },
                        ],
                    },
                },
            },

            activeResultsType: null,
        }
    },

    mounted() {},

    methods: {
        sumbitClicked(filters) {
            this.category = filters.category
            this.perfecture = filters.perfecture

            this.getResults()
        },

        resultsTabsLinkClicked(id) {
            this.activeResultsType.tabs.activeId = id

            this.scrollToResults()
        },

        getResults() {
            const payload = {
                category: this.category,
                perfecture: this.perfecture,
            }

            this.ajax(this.appData.configuration.dataEndpoint, payload, this.storeResults, this.showError)
        },

        storeResults(data) {
            for (const prop in this.resultsTypes) {
                if (data.results[prop] !== null) {
                    this.results = data.results[prop]
                    this.activeResultsType = this.resultsTypes[prop]
                    this.activeResultsType.tabs.activeId = this.activeResultsType.tabs.links[0]?.id
                }
            }

            this.scrollToResults()
        },

        showError() {
            this.results = null

            this.scrollToResults()
        },

        scrollToResults() {
            this.$nextTick(() => {
                const offset = window.innerWidth < lib.breakpoints.desktop ? 100 : window.innerWidth < 1280 ? 240 : 200

                lib.moveWindowToObj(jQuery(this.$el).find('.s-statistics__results'), offset * -1)
            })
        },
    },
}
